module.exports = __webpack_public_path__ + "static/img/yizhangtu_001.973e5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yizhangtu_001.png
// module id = nBOQ
// module chunks = 1